import React from 'react'
import styled from 'styled-components'
import { media } from '../../../utils/style'
import IconStrokeArrow from '../../../vectors/IconStrokeArrow'

const StyledPromo = styled.a`
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 4px;
  position: relative;
  background-color: ${(props) =>
    props.alt ? props.theme.colors.blue : props.theme.colors.green};
  text-shadow: 0 0 3px
    ${(props) =>
      props.alt ? props.theme.colors.blue : props.theme.colors.green};
  color: ${(props) => props.theme.colors.white};
  /* font-family: $font-heading; */
  text-decoration: none;
  transition: all 0.3s ease-in-out;
  min-width: spacing(20);
  text-align: center;
  background-size: contain;
  background-position: 100% 50%;
  background-repeat: no-repeat;
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover,
  &:focus,
  &:active {
    transition-duration: 0.1s;
    box-shadow: 0 0 0 1px white inset,
      0 0 0 4px
        ${(props) =>
          props.alt
            ? props.theme.colors.blue_op30
            : props.theme.colors.green_op30};
  }

  @media (max-width: ${(props) => props.theme.mediaBreakpoints[0] - 1}px) {
    background-image: none !important;
  }

  ${media.MediumScreenUp`
    border-radius: $radius-standard;
    text-align: left;
    justify-content: flex-start;
    min-height: 80px;
  `}
`

const StyledPromoContent = styled.div`
  position: relative;
  padding: 12px 16px 16px;
  ${media.MediumScreenUp`
    padding-left: 24px;
    padding-right: 24px;
  `};
  ${media.LargeScreenUp`
    max-width: 80%;
  `};
`

const Arrow = styled(IconStrokeArrow)`
  position: absolute;
  top: -25%;
  right: 120px;
  height: 150%;
  display: none;

  g {
    fill: ${(props) => props.theme.colors.white_op65};
  }

  ${media.MediumScreenUp`
    display: block;
  `};
`

const Inline = styled.div`
  display: flex;
  flex-wrap: wrap;
  pointer-events: none;
  margin: -4px;

  > * {
    pointer-events: auto;
    margin: 4px;
  }
`

const Title = styled.h3`
  font-weight: 700;
  font-size: 14px;
  line-height: 1.5;
  color: ${(props) => props.theme.colors.white};
`

const Description = styled.p`
  font-size: 14px;
  line-height: 1.5;
  color: ${(props) => props.theme.colors.white};
`

export const Promo = ({ title, description, src, to, alt }) => {
  return (
    <StyledPromo alt={alt} href={to} style={{ backgroundImage: `url(${src})` }}>
      <StyledPromoContent>
        <Inline>
          <Title>{title}</Title>
          {description && <Description>{description}</Description>}
        </Inline>
      </StyledPromoContent>
      <Arrow />
    </StyledPromo>
  )
}
